module.exports = __webpack_public_path__ + "img/community-norm-me_en.b9c5e353.png";